import instagram from "./instagram.svg"
import location from "./location.png"
import linkedin from "./linkedin.svg"
import github from "./github.svg"
import close from "./close.svg"
import menu from "./menu.svg"

const iconsMapping = {
    instagram,
    location,
    linkedin,
    github,
    close,
    menu,
}

export default iconsMapping;